import { useIntl } from "react-intl";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Button, Icon, Input, Modal, Form } from "semantic-ui-react";
// UI
import PeriodontiumExamUX from "../PeriodontiumExamUX";
import PeriodontiumHistoryUX from "../PeriodontiumHistoryUX";
import PlaqueRecordUX from "./PlaqueRecordUX";
import ExaminationImageOverlay from "./ExaminationImageOverlay";

const FORM_FIELD_STYLE = { padding: "3px", width: "90px" };

const PlaqueRecord = (props) => {
  const intl = useIntl();
  const [openPhysicalExam, setOpenPhysicalExam] = useState<boolean>(false);
  const [openPeriodontium, setOpenPeriodontium] = useState<boolean>(false);
  const [settings, setSettings] = useState<any>({});

  useEffect(() => {
    if (props.missingteeth && props.encounterInfo && props.partialmissingteeth) {
      handleSetPlaqueSettings();
    }
  }, [props.missingteeth, props.encounterInfo, props.partialmissingteeth]);

  const handleSetPlaqueSettings = () => {
    let { missingteeth, partialmissingteeth } = props;
    missingteeth = missingteeth.filter((miss) => [1, 2, 3, 4].includes(miss.q));
    partialmissingteeth = partialmissingteeth.filter((miss) => [1, 2, 3, 4].includes(miss.q));
    let plaque = {};
    let bleeding = {};
    // console.log("missingteeth ", missingteeth)
    // console.log("partialmissingteeth ", partialmissingteeth)

    // for (const teeth of partialmissingteeth) {
    //   // console.log(" teett",teeth)
    //   const setPlaque = onSetPropertySettings(teeth, [1, 2, 3, 4], "P");
    //   const setBleed = onSetPropertySettings(teeth, [1, 2, 3, 4, 5, 6], "B");

    //   // console.log("setPlaque ,", setPlaque)
    //   // console.log("setBleed ,", setBleed)
    //   plaque = { ...plaque, ...setPlaque };
    //   bleeding = { ...bleeding, ...setBleed };
    // }

    for (const teeth of missingteeth) {
      // console.log(" teett",teeth)
      const setPlaque = onSetPropertySettings(teeth, [1, 2, 3, 4], "P");
      const setBleed = onSetPropertySettings(teeth, [1, 2, 3, 4, 5, 6], "B");

      // console.log("setPlaque2 ,", setPlaque)
      // console.log("setBleed2 ,", setBleed)

      plaque = { ...plaque, ...setPlaque };
      bleeding = { ...bleeding, ...setBleed };
    }
    setSettings({ ...plaque, ...bleeding });
  };

  const onSetPropertySettings = (data, list, key) => {
    const result: any = {};
    list.forEach((value) => {
      const settle = {
        visibility: "hidden",
      };
      result[`${key}${data.q}${data.i}${value}`] = settle;
    });
    return result;
  };

  // Periodontium Record
  const handleChangePeriodontiumRecordData = (event, data) => {
    props.onEvent({ message: "handleChangePeriodontiumRecordData", params: data });
  };

  const handleSavePeriodontiumRecordData = (event: any) => {
    const record = props.periodontiumRecord;
    const target = event.target;

    if (target.getAttribute("tmp_value") === target.value) {
      return;
    }

    props.onEvent({
      message: "handleSavePeriodontiumRecordData",
      params: {
        data: {
          ...record,
          data: {
            ...record.data,
            plaque: record.tmp_plaque,
            bleeding: record.tmp_bleeding,
          },
          invert: ["plaque", "bleeding"],
          tmp_plaque: record.data.plaque,
          tmp_bleeding: record.data.bleeding,
          editing_psr: target.getAttribute("name"),
        },
      },
    });
  };

  // Periodontium History
  const handleOpenPeriodontalHistory = () => {
    if (props.patientDetail?.id) {
      props.onEvent({ message: "handleGetPeriodontiumHistory" });
      setOpenPeriodontium(true);
    }
  };

  const handleClosePeriodontalHistory = () => {
    setOpenPeriodontium(false);
  };

  // Periodontium Exam
  const handleOpenPeriodontalExam = () => {
    if (props.encounterInfo?.id) {
      props.onEvent({ message: "handleGetPeriodontalExam" });
      setOpenPhysicalExam(true);
    }
  };

  const handleClosePeriodontalExam = () => {
    setOpenPhysicalExam(false);
  };

  const handleSavePeriodontalExam = () => {
    // props.onEvent({ message: "handleSavePeriodontalExam" });
    props.onEvent({ message: "SaveEvaluationForm", params: { form: "periodontalExamData" } });
    handleClosePeriodontalExam();
  };

  const handleClearInput = (checkedIndex: number, uncheckedIndex: number, clearIndex: number | null, name: string, label: string) => {
    props.onEvent({
      message: "SetCheckedPeriodontalExam",
      params: { name: `${name}${uncheckedIndex}`, value: false, text: label },
    });

    if (clearIndex) {
      props.onEvent({
        message: "SetCheckedPeriodontalExam",
        params: { name: `${name}${clearIndex}`, value: "", text: "", input: true },
      });

      props.onEvent({
        message: "SetCheckedPeriodontalExam",
        params: { name: `${name}${checkedIndex}`, value: false, text: label },
      });
    } else {
      props.onEvent({
        message: "SetCheckedPeriodontalExam",
        params: { name: `${name}${3}`, value: "", text: "", input: true },
      });
      props.onEvent({
        message: "SetCheckedPeriodontalExam",
        params: { name: `${name}${checkedIndex}`, value: true, text: label },
      });
    }

    // if (clearIndex) {
    //   props.onEvent({
    //     message: "SetCheckedPeriodontalExam",
    //     params: { name: `${name}${clearIndex}`, value: "", text: "", input: true },
    //   });
    // }
    // props.onEvent({
    //   message: "SetCheckedPeriodontalExam",
    //   params: { name: `${name}${checkedIndex}`, value: true, text: label },
    // });
    // props.onEvent({
    //   message: "SetCheckedPeriodontalExam",
    //   params: { name: `${name}${uncheckedIndex}`, value: false, text: label },
    // });
  };

  const handleSavePeriodontiumRecord = (type: string) => () => {
    const record = props.periodontiumRecord;
    const invert = type === "Plaque" ? "bleeding" : "plaque";
    const lower = type.toLowerCase();

    record.data[lower] = record.data[lower] || [];

    props.onEvent({
      message: "handleSavePeriodontiumRecordData",
      params: {
        data: {
          ...record,
          [`${lower}_index`]: props.onEvent({ message: `Calculate${type}Index`, params: record.data[lower] }),
          data: {
            ...record.data,
            [invert]: record[`tmp_${invert}`],
          },
          invert: [invert],
          [`tmp_${invert}`]: record.data[invert],
        },
      },
    });
  };

  const handleFocusPeriodontiumRecord = (e: any) => {
    e.target.setAttribute("tmp_value", e.target.value);
  };

  // console.log(" PlaqueRecord render settings: ", settings)
  // console.log(" PlaqueRecord render props: ", props);

  return (
    <div
      // className="plaque-area"
      // issue 52820
      style={{
        ...{ cursor: props.encounterInfo ? "default" : "cell" },
        padding: "20px 0px",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "pink",
      }}
    >
      <Form>
        <div className="plaque-tooth-area svg-plague-zoom-out">
          <ExaminationImageOverlay
            imageKey="periodontium"
            sub={props.sub}
            historyReviewSubTab={props.historyReviewSubTab}
            clinicalFindings={props.clinicalFindings}
            filterClinicalFindingIds={props.filterClinicalFindingIds}
            showDrawingChecked={props.showDrawingChecked}
            hideTooltip={true}
            firstPosition={true}
            height="270"
          >
            <PlaqueRecordUX
              onEvent={props.onEvent}
              settings={settings}
              encounterInfo={props.sub === "DiagnosisHistory" || props.sub === "TreatmentHistory" ? props.periodontiumRecord.data : props.encounterInfo}
            />
          </ExaminationImageOverlay>
        </div>
        <Button
          color="green"
          size="mini"
          disabled={!props.periodontiumRecord.editing_plaque}
          style={{
            position: "absolute",
            right: "8rem",
            top: "2.65rem",
          }}
          onClick={handleSavePeriodontiumRecord("Plaque")}
        >
          Save
        </Button>
        <Button
          color="green"
          size="mini"
          disabled={!props.periodontiumRecord.editing_bleeding}
          style={{
            position: "absolute",
            right: "8rem",
            top: "10.65rem",
          }}
          onClick={handleSavePeriodontiumRecord("Bleeding")}
        >
          Save
        </Button>
      </Form>

      <div
        className="plaque-score-area"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            paddingRight: "100px",
          }}
        >
          {/* hiddenEvaluation for Gen report only */}
          {!props.hiddenEvaluation && (
            <div onClick={handleOpenPeriodontalHistory} style={{ marginTop: "5px" }}>
              <Button circular icon style={{ color: "white", backgroundColor: "blue" }}>
                <Icon name="history" />
              </Button>
              <span style={{ color: "#4f4f4f", paddingLeft: "3px" }}>{intl.formatMessage({ id: "cukey96" })}</span>
            </div>
          )}

          <div style={{ display: "flex", alignItems: "center", marginTop: "5px" }}>
            <div style={{ fontWeight: "bold", textAlign: "left", width: "100px" }}>{intl.formatMessage({ id: "cukey160" })}</div>
            <span>
              <Icon className="plaque-icon" inverted circular name="list" />
            </span>
            <Input
              label={{ basic: true, content: "%" }}
              style={{ width: "67px" }}
              readOnly
              labelPosition="right"
              value={typeof props.periodontiumRecord?.tmp_plaque === "undefined" ? "-" : props.periodontiumRecord?.plaque_index || ""}
            />
          </div>

          <div style={{ display: "flex", alignItems: "center", marginTop: "5px" }}>
            <div style={{ fontWeight: "bold", textAlign: "left", width: "100px" }}>{intl.formatMessage({ id: "cukey2" })}</div>
            <span>
              <Icon inverted circular color="red" name="list" />
            </span>
            <Input
              label={{ basic: true, content: "%" }}
              style={{ width: "67px" }}
              readOnly
              labelPosition="right"
              value={typeof props.periodontiumRecord?.tmp_bleeding === "undefined" ? "-" : props.periodontiumRecord?.bleeding_index || ""}
            />
          </div>

          {/* hiddenEvaluation for Gen report only  */}
          {!props.hiddenEvaluation && (
            <div onClick={handleOpenPeriodontalExam} style={{ marginTop: "5px" }}>
              <Button circular icon style={{ color: "white", backgroundColor: "brown" }}>
                <Icon name="list" />
              </Button>
              <span style={{ color: "#4f4f4f", paddingLeft: "3px" }}>{intl.formatMessage({ id: "cukey75" })}</span>
            </div>
          )}
        </div>

        <div style={{ height: "100px", display: "flex", alignItems: "center", marginTop: "5px" }}>
          <div
            style={{
              padding: "7px",
              marginRight: "5px",
              width: "100px",
              backgroundColor: "#dce5f2",
              color: "#063e82",
              borderRadius: "5px",
              fontWeight: "bold",
            }}
          >
            {intl.formatMessage({ id: "cukey156" })}
          </div>
          <Form>
            <Form.Group inline style={{ margin: "0", backgroundColor: "#9bb2cd" }}>
              <Form.Field style={FORM_FIELD_STYLE}>
                <Input
                  fluid
                  name="psr_s1"
                  readOnly={!!props.periodontiumRecord?.editing_psr}
                  loading={props.periodontiumRecord?.editing_psr === "psr_s1"}
                  value={props.periodontiumRecord.data?.psr_s1 || ""}
                  onChange={handleChangePeriodontiumRecordData}
                  onBlur={handleSavePeriodontiumRecordData}
                  onFocus={handleFocusPeriodontiumRecord}
                />
              </Form.Field>
              <Form.Field style={FORM_FIELD_STYLE}>
                <Input
                  fluid
                  name="psr_s2"
                  readOnly={!!props.periodontiumRecord?.editing_psr}
                  loading={props.periodontiumRecord?.editing_psr === "psr_s2"}
                  value={props.periodontiumRecord.data?.psr_s2 || ""}
                  onChange={handleChangePeriodontiumRecordData}
                  onBlur={handleSavePeriodontiumRecordData}
                  onFocus={handleFocusPeriodontiumRecord}
                />
              </Form.Field>
              <Form.Field style={FORM_FIELD_STYLE}>
                <Input
                  fluid
                  name="psr_s3"
                  readOnly={!!props.periodontiumRecord?.editing_psr}
                  loading={props.periodontiumRecord?.editing_psr === "psr_s3"}
                  value={props.periodontiumRecord.data?.psr_s3 || ""}
                  onChange={handleChangePeriodontiumRecordData}
                  onBlur={handleSavePeriodontiumRecordData}
                  onFocus={handleFocusPeriodontiumRecord}
                />
              </Form.Field>
              <Form.Field>
                <div>
                  <b>{intl.formatMessage({ id: "cukey217" })}</b>
                </div>
              </Form.Field>
            </Form.Group>
            <Form.Group inline style={{ margin: "0", backgroundColor: "#cdcdcd" }}>
              <Form.Field style={FORM_FIELD_STYLE}>
                <Input
                  fluid
                  name="psr_s4"
                  readOnly={!!props.periodontiumRecord?.editing_psr}
                  loading={props.periodontiumRecord?.editing_psr === "psr_s4"}
                  value={props.periodontiumRecord.data?.psr_s4 || ""}
                  onChange={handleChangePeriodontiumRecordData}
                  onBlur={handleSavePeriodontiumRecordData}
                  onFocus={handleFocusPeriodontiumRecord}
                />
              </Form.Field>
              <Form.Field style={FORM_FIELD_STYLE}>
                <Input
                  fluid
                  name="psr_s5"
                  readOnly={!!props.periodontiumRecord?.editing_psr}
                  loading={props.periodontiumRecord?.editing_psr === "psr_s5"}
                  value={props.periodontiumRecord.data?.psr_s5 || ""}
                  onChange={handleChangePeriodontiumRecordData}
                  onBlur={handleSavePeriodontiumRecordData}
                  onFocus={handleFocusPeriodontiumRecord}
                />
              </Form.Field>
              <Form.Field style={FORM_FIELD_STYLE}>
                <Input
                  fluid
                  name="psr_s6"
                  readOnly={!!props.periodontiumRecord?.editing_psr}
                  loading={props.periodontiumRecord?.editing_psr === "psr_s6"}
                  value={props.periodontiumRecord.data?.psr_s6 || ""}
                  onChange={handleChangePeriodontiumRecordData}
                  onBlur={handleSavePeriodontiumRecordData}
                  onFocus={handleFocusPeriodontiumRecord}
                />
              </Form.Field>
              <Form.Field>
                <div>
                  <b>{intl.formatMessage({ id: "cukey116" })}</b>
                </div>
              </Form.Field>
            </Form.Group>
          </Form>
        </div>
      </div>

      {false && (
        <div
          className="plaque-score-area"
          style={{
            display: "flex",
            flexDirection: "column",
            height: "fit-content",
            alignItems: "flex-start",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", marginTop: "5px" }}>
            <div style={{ fontWeight: "bold", textAlign: "left", width: "100px" }}>{intl.formatMessage({ id: "cukey160" })}</div>
            <span>
              <Icon className="plaque-icon" inverted circular name="list" />
            </span>
            <Input
              label={{ basic: true, content: "%" }}
              style={{ width: "67px" }}
              readOnly
              labelPosition="right"
              value={props.periodontiumRecord.plaque_index || ""}
            />
          </div>

          <div style={{ display: "flex", alignItems: "center", marginTop: "5px" }}>
            <div style={{ fontWeight: "bold", textAlign: "left", width: "100px" }}>{intl.formatMessage({ id: "cukey1" })}</div>
            <span>
              <Icon inverted circular color="red" name="list" />
            </span>
            <Input
              label={{ basic: true, content: "%" }}
              style={{ width: "67px" }}
              readOnly
              labelPosition="right"
              value={props.periodontiumRecord.bleeding_index || ""}
            />
          </div>
          <div style={{ height: "100px", display: "flex", width: "100%", alignItems: "center", marginTop: "5px" }}>
            <div
              style={{
                padding: "7px",
                marginRight: "5px",
                width: "85px",
                backgroundColor: "#dce5f2",
                color: "#063e82",
                borderRadius: "5px",
                fontWeight: "bold",
              }}
            >
              {intl.formatMessage({ id: "cukey156" })}
            </div>
            <Form>
              <Form.Group inline style={{ margin: "0", backgroundColor: "#9bb2cd" }}>
                <Form.Field style={FORM_FIELD_STYLE}>
                  <Input
                    fluid
                    name="psr_s1"
                    value={props.periodontiumRecord.data?.psr_s1 || ""}
                    onChange={handleChangePeriodontiumRecordData}
                    onBlur={handleSavePeriodontiumRecordData}
                  />
                </Form.Field>
                <Form.Field style={FORM_FIELD_STYLE}>
                  <Input
                    fluid
                    name="psr_s2"
                    value={props.periodontiumRecord.data?.psr_s2 || ""}
                    onChange={handleChangePeriodontiumRecordData}
                    onBlur={handleSavePeriodontiumRecordData}
                  />
                </Form.Field>
                <Form.Field style={FORM_FIELD_STYLE}>
                  <Input
                    fluid
                    name="psr_s3"
                    value={props.periodontiumRecord.data?.psr_s3 || ""}
                    onChange={handleChangePeriodontiumRecordData}
                    onBlur={handleSavePeriodontiumRecordData}
                  />
                </Form.Field>
                <Form.Field>
                  <div>
                    <b>{intl.formatMessage({ id: "cukey217" })}</b>
                  </div>
                </Form.Field>
              </Form.Group>
              <Form.Group inline style={{ margin: "0", backgroundColor: "#cdcdcd" }}>
                <Form.Field style={FORM_FIELD_STYLE}>
                  <Input
                    fluid
                    name="psr_s4"
                    value={props.periodontiumRecord.data?.psr_s4 || ""}
                    onChange={handleChangePeriodontiumRecordData}
                    onBlur={handleSavePeriodontiumRecordData}
                  />
                </Form.Field>
                <Form.Field style={FORM_FIELD_STYLE}>
                  <Input
                    fluid
                    name="psr_s5"
                    value={props.periodontiumRecord.data?.psr_s5 || ""}
                    onChange={handleChangePeriodontiumRecordData}
                    onBlur={handleSavePeriodontiumRecordData}
                  />
                </Form.Field>
                <Form.Field style={FORM_FIELD_STYLE}>
                  <Input
                    fluid
                    name="psr_s6"
                    value={props.periodontiumRecord.data?.psr_s6 || ""}
                    onChange={handleChangePeriodontiumRecordData}
                    onBlur={handleSavePeriodontiumRecordData}
                  />
                </Form.Field>
                <Form.Field>
                  <div>
                    <b>{intl.formatMessage({ id: "cukey116" })}</b>
                  </div>
                </Form.Field>
              </Form.Group>
            </Form>
          </div>
        </div>
      )}

      <Modal onClose={handleClosePeriodontalHistory} size="small" open={openPeriodontium}>
        <PeriodontiumHistoryUX
          periodontiumHistoryList={props.periodontiumHistoryList}
          historyColumn={[
            { Header: "Date", accessor: "created", width: 250 },
            {
              Header: "Plaque %",
              width: 220,
              Cell: ({ original }: any) => {
                return <div style={{ textAlign: "right" }}>{typeof original.data.plaque === "undefined" ? "-" : original.plaque_index}</div>;
              },
            },
            {
              Header: "Bleeding %",
              width: 220,
              Cell: ({ original }: any) => {
                return <div style={{ textAlign: "right" }}>{typeof original.data.bleeding === "undefined" ? "-" : original.bleeding_index}</div>;
              },
            },
          ]}
        />
        <div style={{ padding: "10px" }}>{"แสดงเครื่องหมาย (-) คือ ไม่มีการบันทึกและลงข้อมูลทำให้ไม่เกิดการคำนวณ"}</div>
      </Modal>

      <Modal onClose={handleClosePeriodontalExam} open={openPhysicalExam}>
        <PeriodontiumExamUX
          // function
          onEvent={props.onEvent}
          setProp={props.setProp}
          handleSavePeriodontalExam={handleSavePeriodontalExam}
          handleClearInput={handleClearInput}
          // data
          periodontalExamData={props.periodontalExamData?.data}
        />
      </Modal>
    </div>
  );
};

PlaqueRecord.propTypes = {
  onEvent: PropTypes.func,
  setProp: PropTypes.func,
  hiddenEvaluation: PropTypes.bool,

  patientDetail: PropTypes.object,
  encounterInfo: PropTypes.object,
  missingteeth: PropTypes.array,
  partialmissingteeth: PropTypes.array,
  periodontiumRecord: PropTypes.object,
  periodontiumHistoryList: PropTypes.array,
  periodontalExamData: PropTypes.object,
  clinicalFindings: PropTypes.array,
  filterClinicalFindingIds: PropTypes.array,
  showDrawingChecked: PropTypes.array,
  sub: PropTypes.string,
  historyReviewSubTab: PropTypes.number,
};

PlaqueRecord.defaultProps = {
  onEvent: () => {},
  setProp: () => {},

  hiddenEvaluation: false,
  patientDetail: {},
  encounterInfo: {},
  missingteeth: [],
  partialmissingteeth: [],
  periodontiumRecord: {},
  periodontiumHistoryList: [],
  periodontalExamData: {},
  clinicalFindings: [],
  filterClinicalFindingIds: [],
  showDrawingChecked: [],
  sub: "",
  historyReviewSubTab: 0,
};

export default PlaqueRecord;
